// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalStartVisit_wrapper__1XvIc","actionWrapper":"ModalStartVisit_actionWrapper__2jHzB","notesConfirm":"ModalStartVisit_notesConfirm__xauAg"};